import { render } from "./SearchRefineIcon.vue?vue&type=template&id=c6bbe5c6"
import script from "./SearchRefineIcon.vue?vue&type=script&lang=js"
export * from "./SearchRefineIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__